var LocaleService = require('services/locale-service');
var AudioService = require('services/audio-service');
import LoadService from 'services/load-service';
var EnrollmentDataService = require('services/enrollment-data-service');
var utils = require('lib/utils');

/* global handleRequestFromContent:true */
/* global dynaHypeParentFunctionCall:true */
/* global dynaHypeImageSwap:true */
/* global dynaHypeTextFill:true */
/* global dynaHypePlaySound:true */
/* global dynaHypeGetParam:true */
/* global dynaHypeHandleMsg:true */
/* global dynahypedata:true */

var windowfunctionlist = ['handleRequestFromContent', 'dynaHypeParentFunctionCall', 'dynaHypeImageSwap', 'dynaHypeTextFill', 'dynaHypePlaySound', 'dynaHypeGetParam', 'dynaHypeHandleMsg'];
var dynahypewindowfunctions = {
  handleRequestFromContent: function(myrequest) {
      return dynaHypeParentFunctionCall(myrequest,'');
    },
  dynaHypeParentFunctionCall: function(req, hypeDocument) {
      var reqArr = req.split(';');
      switch(reqArr[0]) {
        case 'goNext' :
          // go forward one slide
          if(window.Chaplin) {
            Chaplin.mediator.publish('page:navigate', 'forward');
          }
          break;
        case 'goBack' :
          // go back one slide
          if(window.Chaplin) {
            Chaplin.mediator.publish('page:navigate', 'back');
          }
          break;
        case 'audioCompleted' :
          // track the page completion
          dynaHypeHandleMsg('warn','function not supported by current GUI (audioCompleted)');
          break;
        case 'pageCompleted' :
          // track the page completion
          Chaplin.mediator.publish('dynahype:pagecompleted', this, hypeDocument, arguments);
          break;
        case 'setScoreComplete' :
          // send score to LMS and mark SCO completed
          dynaHypeHandleMsg('warn','function not supported by current GUI (setScoreComplete)');
          break;
        case 'setCompleted' :
          // mark SCO completed
          dynaHypeHandleMsg('warn','function not supported by current GUI (completeSCO)');
          break;
        case 'setSuspendData' :
          // send SuspendData to LMS
          dynaHypeHandleMsg('warn','function not supported by current GUI (setSuspendData)');
          // probably should serialize the suspenddata according to assetname & pagenum (e.g., "&hypeasset12=blah,blah")
          // check data string for reserved chars (&="')
          break;
        case 'sendInteractions' :
          // send interaction data to LMS
          dynaHypeHandleMsg('warn','function not supported by current GUI (sendInteractions)');
          break;
        case 'closeSCOnow' :
          // mark SCO completed
          if(window.Chaplin) {
            Chaplin.mediator.publish('page:navigate', 'menu');
          }
          break;
        case 'setAdHocParam' :
          // used for communication from one slide to another
          var paramarr = reqArr[1].split(',');
          EnrollmentDataService.saveData(paramarr[0],paramarr[1]);
          break;
        case 'getAdHocParam' :
          // used for communication from one slide to another
          return EnrollmentDataService.getData(reqArr[1]);
        case 'playSoundEffect' :
          // sound effects
          dynaHypeHandleMsg('warn','function not supported by current GUI (getAdHocParam)');
          break;
        default :
          dynaHypeHandleMsg('error',"unexpected param in handleRequestFromContent('"+reqArr[0]+"')");
          break;
      }
      return '';
    },
  dynaHypeImageSwap: function(divid, hypeDocument) {
      if(window.Chaplin) {
        Chaplin.mediator.publish('dynahype:imageswap', this, arguments[0], arguments[1], arguments);
      }
    },
  dynaHypeTextFill: function(divid, max_fontsize, hypeDocument) {
      if(window.Chaplin) {
        Chaplin.mediator.publish('dynahype:textfill', this, arguments[0], arguments[1], arguments[2], arguments);
      }
    },
  dynaHypePlaySound: function(mysoundname,mytimeline,hypeDocument) {
      //
      Chaplin.mediator.publish('media:narration', LocaleService.t(dynahypedata.assetdata.params['audios-'+mysoundname+'-langstring']));
      //
      var audiopath = utils.coursePath("audio/"+LocaleService.t(dynahypedata.assetdata.params['audios-'+mysoundname+'-langfile']));
      var audio_id = audiopath.replace(/\//g , '_');
      AudioService.load(audio_id, { loadPath: audiopath })
        .done(function( sound ) {
          window.dynahypedata.mysound = sound;
          Chaplin.mediator.publish('dynahype:playsound', this, arguments[0], sound);
          window.dynahypedata.mysound.on('complete', function() {
            Chaplin.mediator.publish('media:ended', audio_id); // window.dynahypedata.assetdata['model']['audio_id']
            Chaplin.mediator.publish('media:ended:' + audio_id);
            Chaplin.mediator.publish('audio:ended:' + audio_id);
          }, this, true);
          window.dynahypedata.mysound.play();
          var dateObject = new Date();
          window.starttime = dateObject.getTime();
        });
      //
      Chaplin.mediator.publish(`media:playing:${audio_id}`);
      Chaplin.mediator.publish(`audio:playing:${audio_id}`);
      Chaplin.mediator.publish('media:status:changed', 'playing', audio_id);
      window.dynahypedata.audiostarted = true;
    },
  dynaHypeGetParam: function(myparam, hypeDocument) {
      var reqArr = myparam.split(';');
      var cl = window.dynahypedata.assetdata.metadata.currentlanguage;
      if(typeof(cl) != 'undefined') cl = 'en';
      switch(reqArr[0]) {
        case 'audioCurrentTime' :
          var ct = Math.floor(window.dynahypedata.mysound.position)/1000; // parent.audioElement.currentTime;
          var dur = Math.floor(window.dynahypedata.mysound.duration)/1000; // parent.audioElement.duration;
          //
          //console.log("pos:"+ct);
          if(ct < 0 || ct >= dur) {
            // no audio playing
            return 0;
          } else if(window.dynahypedata.audiostarted) {
            return ct;
          } else {
            // audio is still being prepared for playback, don't return zero because it will kill the sync function
            return 0.001;
          }
          break;
        case 'animationCuesJSON' :
          // TTD *** import cues if they exist
          // format is json, timecodes are in milliseconds
          if(typeof(window.dynahypedata.animationcues) != 'undefined') {
            //alert("success getting animation cues");
            return window.dynahypedata.animationcues;
          } else {
            return {};
          }
          break;
        case 'gestureCuesJSON' :
          // TTD *** import cues if they exist
          // format is json, timecodes are in milliseconds
          if(typeof(window.dynahypedata.gesturecues) != 'undefined') {
            //alert("success getting gesture cues");
            return window.dynahypedata.gesturecues;
          } else {
            return {};
          }
          break;
        case 'assetConfig' :
          // this can be any string -- can be used to control specific digital asset behaviors
          var configstring;
          if(typeof(dynahypedata.assetdata.params['strings-assetconfig']) != 'undefined') {
            configstring = dynahypedata.assetdata.params['strings-assetconfig'];
            return configstring;
          } else {
            return '';
          }
          break;
        case 'languageFormat' :
          if(LocaleService.isRTL()) {
            return 'rtl';
          } else {
            return 'ltr';
          }
          break;
        case 'languageCode' :
          // ISO language codes
          if(typeof(cl) != 'undefined') {
            return cl;
          } else {
            return 'en';
          }
          break;
        case 'getVideoHTML' :
          // 
          var mp4videopath = false;
          var ogvvideopath = false;
          var webmvideopath = false;
          if(typeof(dynahypedata.assetdata.params['mp4-videos-'+reqArr[1]+'-langfile']) != 'undefined') {
            mp4videopath = dynahypedata.assetdata.params['mp4-videos-'+reqArr[1]+'-langfile'];
          }
          if(typeof(dynahypedata.assetdata.params['ogv-videos-'+reqArr[1]+'-langfile']) != 'undefined') {
            ogvvideopath = dynahypedata.assetdata.params['ogv-videos-'+reqArr[1]+'-langfile'];
          }
          if(typeof(dynahypedata.assetdata.params['webm-videos-'+reqArr[1]+'-langfile']) != 'undefined') {
            webmvideopath = dynahypedata.assetdata.params['webm-videos-'+reqArr[1]+'-langfile'];
          }
          //
          var subtitlepath = false;
          if(typeof(dynahypedata.assetdata.params['subtitles-'+reqArr[1]+'-langstring']) != 'undefined') {
            subtitlepath = dynahypedata.assetdata.params['subtitles-'+reqArr[1]+'-langstring'];
          }
          //
          var videohtml = '';
          videohtml += "<video id='vid_"+reqArr[1]+"' width='680' height='400'>";
          videohtml += (mp4videopath ? "<source type='video/mp4' src='"+mp4videopath+"'>" : '<!--no MP4-->');
          videohtml += (ogvvideopath ? "<source type='video/ogg' src='"+ogvvideopath+"'>" : '<!--no OGV-->');
          videohtml += (webmvideopath ? "<source type='video/webm' src='"+webmvideopath+"'>" : '<!--no WEBM-->');
          videohtml += (subtitlepath ? "<track label='"+parent.currentlang+"' kind='subtitles' srclang='"+cl+"' src='hype/"+subtitlepath+"' default>" : '<!--no subtitle track-->');
          videohtml += '</video>';
          return videohtml;
          //
        case 'muteState' :
          // *** TTD - implement this
          return false;
        case 'pauseState' :
          // *** TTD - implement this
          return false;
        case 'string' :
          // 
          var mystring;
          if(typeof(dynahypedata.assetdata.params['strings-'+reqArr[1]+'-langstring']) != 'undefined') {
            mystring = dynahypedata.assetdata.params['strings-'+reqArr[1]+'-langstring'];
            return mystring;
          } else {
            return '';
          }
          break;
        default :
          dynaHypeHandleMsg('error','dynaHypeGetParam error - unexpected param name = '+reqArr[0]);
          break;
      }
    },
  dynaHypeHandleMsg: function(type, msg, hypeDocument) {
      if(window.Chaplin) {
        Chaplin.mediator.publish('dynahype:handlemsg', this, arguments[0], arguments[1], arguments[2], arguments);
      }
    }};
    
var DynahypeService = {
  initialize: function() {
    //
  },
  load: function(assetdata) {
    //
    window.dynahypedata = {};
    window.dynahypedata.assetdata = assetdata;
    window.dynahypedata.audiostarted = false;
    window.dynahypedata.mysound = undefined;
    // cues
    window.dynahypedata.animationcues = undefined;
    window.dynahypedata.gesturecues = undefined;
    // not sure (yet) if useful
    window.dynahypedata.pausestate = 'init'; // TTD *** add support for pause/play
    //
    for(var i = 0, len = windowfunctionlist.length; i < len; i++) {
      window[windowfunctionlist[i]] = dynahypewindowfunctions[windowfunctionlist[i]]; // Might want to make `this` for the function something useful, up to you -- like window maybe? window[key] = this[key].bind(window);
    }
    //
    if((typeof(dynahypedata.assetdata.params['cues-animationcues-langfile']) != 'undefined') && (typeof(dynahypedata.assetdata.params['cues-gesturecues-langfile']) != 'undefined')) {
      this.files = {
        'animationcues': 'hype/'+LocaleService.t(dynahypedata.assetdata.params['cues-animationcues-langfile']),
        'gesturecues': 'hype/'+LocaleService.t(dynahypedata.assetdata.params['cues-gesturecues-langfile'])
      };
      LoadService.load(this.files)
        .then(function (data) {
          window.dynahypedata.animationcues = data.animationcues;
          window.dynahypedata.gesturecues = data.gesturecues;
          //console.log("cues loaded!!");
        })
        .catch(function () {
          window.dynahypedata.animationcues = [{ 'time': '0', 'cuetype': 'speaker', 'data': '1' }];
          window.dynahypedata.gesturecues = [{ 'time': 10, 'cuetype': 'avatar1', 'data': '1' }];
        });
    }
  },
  dispose: function() {
    for(var i = 0, len = windowfunctionlist.length; i < len; i++) {
      delete window[windowfunctionlist[i]];
    }
  }
};

module.exports = DynahypeService;